export const LOCAL_STORAGE_AUTH_KEY = 'token';

export const ACTIONS = {
  SET_AUTH_TOKEN: "SET_AUTH_TOKEN",
  REMOVE_AUTH_TOKEN: "REMOVE_AUTH_TOKEN",
  SET_TOAST_MESSAGE: "SET_TOAST_MESSAGE",
  REMOVE_TOAST: "REMOVE_TOAST",
  SET_FORM_DATA:"SET_FORM_DATA"
}